<template>
  <div class="c-push">
    <push-entrepreneur v-if="target && isEntrepreneurPage" :page="page" />
    <app-section v-else-if="target && !isEntrepreneurPage" class="-push" :bgIntro="isEntrepreneurPage ? 'dark' : null">
      <template #intro>
        <push-section :page="page" />
      </template>
    </app-section>
  </div>
</template>

<script>
import AppSection from "layout/AppSection";
import Push from "components/Push/Push";
import PushEntrepreneur from "components/Push/PushEntrepreneur";
import { routes } from "src/router";

export default {
  name: "Push",
  components: {
    AppSection,
    // AnimText,
    // EntrepreneurPush,
    PushEntrepreneur,
    PushSection: Push
  },
  props: {
    page: {
      type: Object,
      required: true
    },
    isEntrepreneurPage: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    target() {
      return this.page ? this.page.type : false;
    },
    route() {
      return routes.find(route => route.meta.prismicHandle === this.target);
    },
    isSingle() {
      return !!this.route.meta.single;
    },
    path() {
      return this.isSingle ? this.route.path : this.route.path.replace(":uid", this.page.uid);
    },
    title() {
      return this.isSingle ? this.$store.getters["global/getSingleTitle"](this.target) : this.page.data.title;
    }
  }
};
</script>

<style lang="scss">
.c-push {
  display: flex;
  flex: 1;
  height: 100%;
  &--entrepreneur {
  }
}
</style>
